import { faL } from "@fortawesome/free-solid-svg-icons";
import apiClient, { getBenefitsDictionary } from "../../../../../../services/apiClient";

const getFullYear = (d2, period) => {
    const d1 = [period,"10","01"].join('-') + 'T00:00:00';
    const month = new Date(d2).getMonth() > new Date(d1).getMonth() ? new Date(d1).getMonth() - new Date(d2).getMonth() : new Date(d1).getMonth() + (12 - new Date(d2).getMonth());
    const year = new Date(d2).getMonth() > new Date(d1).getMonth() ? new Date(d1).getFullYear() - new Date(d2).getFullYear() : new Date(d1).getFullYear() - new Date(d2).getFullYear() -1;
    return year + (month-1)/12;
};

const zdoRequestsApi = {
  async getRequestsToKindergarten(kgid, period = 'all', minAge = null) {

    

    let linkPost = '';

    if(period && period !== 'all') {
        linkPost = `requests/queue_to_kindergarten?kgid=${kgid}`;
        
        if (period && period !== 'all') {
          linkPost += `&period=${period}`;
        }
        
        if (minAge >= 0) {
          linkPost += `&min_age=${minAge}`;
        }

            const data = await apiClient.get(linkPost);
    
            return {
              requests: data.data?.cursor || [],
              myRequests: data.data?.my_requests || [] // Добавляем массив ID заявок пользователя
            };
    } else {
      linkPost = `requests/main_info?with_selected_kindergarten=${kgid}&without_statuses=child-in-kindergarten,removed`;

      //linkPost = `requests/queue_to_kindergarten?kgid=${kgid}&period=2025`;

        if (minAge >= 0) {
          linkPost += `&min_age=${minAge}`;
        }


      const data = await apiClient.get(linkPost);

      const filteredData = data.data?.filter(r=>r.ageLimitFrom < 8) || [];
    
      return {
        requests: filteredData,
        //myRequests: data.data?.my_requests || [] // Добавляем массив ID заявок пользователя
      };

    }



  },

  async getUserRequests(userEmail) {
    const linkPost = `requests?email=${userEmail}`;

    const data = await apiClient.get(linkPost);

    return data.data || [];

  },
  async getPeriodsActive(){

    const url = `references/academic-years?status=active`;

    try{

      const result = await apiClient.get(url);

      return result.data?.data?.filter(d=>["active"].includes(d.status))
      .filter(d=>new Date() > new Date(d.additionalFields.publicDisplayStart) )
      .map(d=>+d.additionalFields.year) || [];

    } catch (err){
      return err;
    }

  },

  filterRequests(requests, minage, period) {
    return requests.filter((item) => {
      const status = item.currentStatus.name;
      return status === 'approved' ||
             status === 'need-additional-check' ||
             status === 'invite-sent' ||
             status === 'invite-accepted' ||
             status === 'invite-declined';
    }).
    map(item => {
      const ageFromYear = item.youngerGroup ? getFullYear(item.ageFromMs, period) - 1 : getFullYear(item.ageFromMs, period);
      
      switch (minage) {
        case 1.5:
          // Для min_age = 1.5 сохраняем точное значение возраста
          if (ageFromYear >= 1.5 && ageFromYear < 2) {
            item['ageLimitFrom'] = 1.5; // Сохраняем как 1.5 для корректной группировки
          } else {
            item['ageLimitFrom'] = parseInt(ageFromYear);
          }
          break;
        default:
          item['ageLimitFrom'] = parseInt(ageFromYear);
          break;
      }
      
      item['ageLimitTo'] = item['ageLimitFrom'] + 1;
      item['periodFrom'] = parseInt(period);
      item['periodTo'] = period + 1;

      return item;
    });
  },

  groupRequestsByAge(requests) {
    const groups = {
      '2-3': [],
      '4-6': []
    };

    requests.forEach(request => {
      const ageFrom = request.ageLimitFrom || 0;
      
      if (ageFrom >= 2 && ageFrom < 4) {
        groups['2-3'].push(request);
      } else if (ageFrom >= 4 && ageFrom <= 6) {
        groups['4-6'].push(request);
      }
    });

    // Сортировка по queueNumber в каждой группе
    Object.keys(groups).forEach(groupId => {
      groups[groupId].sort((a, b) => {
        const queueA = a.queueNumber || Number.MAX_SAFE_INTEGER;
        const queueB = b.queueNumber || Number.MAX_SAFE_INTEGER;
        return queueB - queueA; // Чем меньше queueNumber, тем выше в списке
      });
    });

    return groups;
  },

  transformRequestsData(requests, myRequestsIds = [], benefitsList, kg_id) {


    return requests.map(request => {
      // Определяем дату подачи заявки
      let submittedDate;
      let isRepeated = false;
      
      // Проверяем наличие firstDate и сравниваем с createdAt
      if (request.firstDate) {
        const firstDate = new Date(request.firstDate);
        const createdAt = new Date(request.createdAt);
        
        // Если firstDate существует и раньше createdAt, используем firstDate
        if ((firstDate.getTime() + (24*60*60*1000)) < createdAt.getTime()) {
          submittedDate = this.formatDate(request.firstDate);
          isRepeated = true;
        } else {
          submittedDate = this.formatDate(request.createdAt);
        }
      } else {
        submittedDate = this.formatDate(request.createdAt);
      }

      // Получаем базовую дополнительную информацию
      let additionalInfo = this.getAdditionalInfo(request, benefitsList);
      
      // Добавляем "повторна" если заявка повторная
      if (isRepeated) {
        additionalInfo = additionalInfo !== '—' 
          ? `повторна, ${additionalInfo}`
          : 'повторна';
      }

      // Проверяем, является ли заявка заявкой текущего пользователя
      const isMyRequest = myRequestsIds.includes(request._id);


      const check_invite_in_kg = (invite, status, kg_id)=>{

        if(!invite) return false;

        if(!['invite-accepted'].includes(status)) return false;

        if(invite.kindergartenId !== kg_id) return false;

        if(!invite.isInviteAccepted) return false;


        

        return true;
      }

      return {
        id: request._id, // Добавляем ID заявки
        name: request.child.firstName,
        cert: request.child.birthCertificate.number,
        submitted: submittedDate,
        sendFrom: request.preferDateFrom ? this.formatDate(request.preferDateFrom) : this.formatDate(request.createdAt),
        status: this.mapStatus(request.currentStatus, kg_id),
        acceptButton: check_invite_in_kg(request.invite, request.currentStatus.name, kg_id),
        additional: additionalInfo,
        isRepeated: isRepeated,
        queueNumber: request.queueNumber || Number.MAX_SAFE_INTEGER,
        isMyRequest: isMyRequest // Добавляем флаг принадлежности пользователю
      };
    });
  },

  formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
  },

  mapStatus(apiStatus, kg_id) {
    const statusMap = {
      'approved': 'accepted',
      'need-additional-check': '',
      'invite-declined': 'deleted'
    };

    const statusKg = {
      'invite-accepted': ['docs', 'docsKg'],
      'invite-sent': ['selection', 'selectionKg'],

    }

    
    if(statusMap[apiStatus.name]) return statusMap[apiStatus.name];
    if(statusKg[apiStatus.name]) {
      const { kindergartenId } = apiStatus;
      return kindergartenId == kg_id ? statusKg[apiStatus.name][1] : statusKg[apiStatus.name][0];
    }

    return 'selection';

  },

  // Группировка для вкладки "Наступні": первый уровень — учебный год, второй — возраст
  groupRequestsByYearAndAge(requests) {
    // requests — уже отфильтрованный (filterRequests) массив, но для 'all'
    // ageLimitFrom / periodFrom берём прямо из объекта (API возвращает их готовыми)
    const byYear = {};

    requests.forEach(request => {
      const year = request.periodFrom;
      if (year == null) return;

      if (!byYear[year]) byYear[year] = {};

      const ageFrom = request.ageLimitFrom ?? 0;
      const ageTo = request.ageLimitTo ?? ageFrom + 1;
      const ageKey = `${ageFrom}-${ageTo}`;

      if (!byYear[year][ageKey]) byYear[year][ageKey] = [];
      byYear[year][ageKey].push(request);
    });

    // Сортируем заявки внутри каждой возрастной группы по queueNumber
    Object.values(byYear).forEach(yearGroups => {
      Object.keys(yearGroups).forEach(ageKey => {
        yearGroups[ageKey].sort((a, b) => {
          const qA = a.queueNumber || Number.MAX_SAFE_INTEGER;
          const qB = b.queueNumber || Number.MAX_SAFE_INTEGER;
          return qA - qB;
        });
      });
    });

    return byYear;
  },

  async getBenefitsInfo(){
    return await getBenefitsDictionary();
  },

  getAdditionalInfo(request, benefitsDict) {
    const parts = [];
    
    if (request.indicators && request.indicators.childBenefitsSelected) {


      const benInfo = benefitsDict.find(b=>b._id == request.child.benefits[0]?.benefitId);
      const benefitVerified = request.indicators.childBenefitsVerified;
      if(benefitVerified) parts.push(`Пільга: ${benInfo.name}`);
    }
    
    if (request.specialization && 
        request.specialization.specializationId && 
        request.specialization.medicalProtocol //&& 
        //request.specialization.medicalProtocolDate
        ) {
      //parts.push('ІРЦ');
    }

    if (request.dissabilities && 
        request.dissabilities.specializationId && 
        request.dissabilities.medicalProtocol //&& 
        //request.specialization.medicalProtocolDate
        ) {
      parts.push('ІРЦ');
    }

    const { queueNumber } = request;

    const pr_number = +(queueNumber.slice(0,2));

    if(pr_number == 89) parts.push('Брати та сестри в одному здо');

    if(pr_number > 89 && pr_number < 91) parts.push('Пільга позачергова');
    if(pr_number >= 91 && pr_number < 93) parts.push('Пільга першочергова');
    if(pr_number >= 93 && pr_number < 97) parts.push('Пільга');

    
    if (request.neededPlaceDescription && request.neededPlaceDescription.notWithoutBed) {
      parts.push('тільки повного дня');
    }
 
    if (request.neededPlaceDescription && request.neededPlaceDescription.notWithoutFullDay) {
      parts.push('тільки короткотривале');
    }
    
    if (request.neededPlaceDescription && request.neededPlaceDescription.inclusive) {
      parts.push('інклюзивне');
    }
    
    if (request.languageTraining === 'ir') {
      parts.push('Міжнародний договір');
    }

    if(request.statusMR?.result == "true") {
      parts.push('киянин');
    }
    
    return parts.length > 0 ? parts.join(', ') : '—';
  },

  // Новий метод для отримання черги через buildKindergartenQueueList
async getQueueList(kgid, period, filters = {}, fields = []) {
    const data = await apiClient.post(`buildqueuelist`, {   // <-- post
        kindergartenId: kgid,
        academicYear: period,
        groupNumbers: [],
        requestFilters: {
            languageTraining:  filters.languageTraining  || undefined,
            preferDateBefore:  filters.preferDateBefore  || undefined,
            disabilitiesType:  undefined
        },
        requestFields: fields.length > 0 ? fields : [
            'child.birthCertificate.number',
            'child.secondName',
            'responsiblePerson.contacts.phone',
            'responsiblePerson.contacts.email',
            'invite',
            'createdAt',
            'indicators',
            'statusMR',
            'specialization',
            'dissabilities',  
            'neededPlaceDescription'
        ]
    });
    return data.data || { ageBrackets: [], requests: [], totalRequests: 0 };
},


// Отримання черги для вкладки "Наступні" — ОДРАЗУ по всіх майбутніх
// навчальних роках за один виклик (бек сам розподіляє заявки по роках
// і проставляє їм _periodYear, аналогічно до старого підходу).
async getFutureQueueListAll(kgid, academicYearFrom, filters = {}, fields = []) {
    const data = await apiClient.post(`buildfuturequeuelistall`, {
        kindergartenId: kgid,
        academicYearFrom: academicYearFrom,
        requestFilters: {
            languageTraining:  filters.languageTraining  || undefined,
            preferDateBefore:  filters.preferDateBefore  || undefined
        },
        requestFields: fields.length > 0 ? fields : [
            'child.birthCertificate.number',
            'child.secondName',
            'responsiblePerson.contacts.phone',
            'responsiblePerson.contacts.email',
            'invite',
            'createdAt',
            'indicators',
            'statusMR',
            'specialization',
            'dissabilities',
            'neededPlaceDescription'
        ]
    });
    return data.data || { years: [], totalRequests: 0 };
},

// Трансформує плоский список requests з нового API у структуру { groupId: [...] }
// яку очікує існуючий компонент
transformQueueListToGroups(queueListResponse, myRequestsIds = [], benefitsList, kg_id) {
    const { ageBrackets, requests } = queueListResponse;

    // Індекс метаданих діапазонів по ключу "from-to"
    const bracketsIndex = {};
    ageBrackets.forEach(b => {
        bracketsIndex[`${b.from}-${b.to}`] = b;
    });

    // Групуємо заявки по _bracketFrom/_bracketTo
    const grouped = {};
    requests.forEach(req => {
        const key = `${req._bracketFrom}-${req._bracketTo}`;
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(req);
    });

    // Трансформуємо кожну групу через існуючий transformRequestsData
    const result = {};
    Object.keys(grouped).forEach(key => {
        const transformed = this.transformQueueRequest(
            grouped[key],
            myRequestsIds,
            benefitsList,
            kg_id
        );
        result[key] = transformed;
    });

    // Метадані діапазонів (вільні місця тощо) — зберігаємо окремо
    const bracketsInfo = {};
    ageBrackets.forEach(b => {
        bracketsInfo[`${b.from}-${b.to}`] = b;
    });

    return { grouped: result, bracketsInfo };
},

// Трансформує одну заявку з нового формату (поля схеми) у формат компонента
transformQueueRequest(requests, myRequestsIds = [], benefitsList, kg_id) {
    return requests.map(request => {
        let submittedDate;
        let isRepeated = false;

        if (request.firstDate) {
            const firstDate = new Date(request.firstDate);
            const createdAt = new Date(request.createdAt);
            if ((firstDate.getTime() + (24 * 60 * 60 * 1000)) < createdAt.getTime()) {
                submittedDate = this.formatDate(request.firstDate);
                isRepeated = true;
            } else {
                submittedDate = this.formatDate(request.createdAt);
            }
        } else {
            submittedDate = this.formatDate(request.createdAt);
        }

        let additionalInfo = this.getAdditionalInfo(request, benefitsList);
        if (isRepeated) {
            additionalInfo = additionalInfo !== '—'
                ? `повторна, ${additionalInfo}`
                : 'повторна';
        }

        const isMyRequest = myRequestsIds.includes(request._id);

        const check_invite_in_kg = (invite, status, kg_id) => {
            if (!invite) return false;
            if (!['invite-accepted'].includes(status)) return false;
            if (invite.kindergartenId !== kg_id) return false;
            if (!invite.isInviteAccepted) return false;
            return true;
        };

        return {
            id: request._id,
            name: request.child && request.child.firstName,
            cert: request.child && request.child.birthCertificate && request.child.birthCertificate.number,
            submitted: submittedDate,
            sendFrom: request.preferDateFrom
                ? this.formatDate(request.preferDateFrom)
                : this.formatDate(request.createdAt),
            status: this.mapStatus(request.currentStatus, kg_id),
            acceptButton: check_invite_in_kg(request.invite, request.currentStatus && request.currentStatus.name, kg_id),
            additional: additionalInfo,
            isRepeated,
            queueNumber: request.queueNumber || Number.MAX_SAFE_INTEGER,
            isMyRequest,
            // Зберігаємо мітки діапазону для можливого використання
            _bracketFrom: request._bracketFrom,
            _bracketTo: request._bracketTo,
            _bracketLabel: request._bracketLabel
        };
    });
},

};


export { zdoRequestsApi };